import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DhhpAlertComponent } from '../../shared/dhhpalert/dhhpalert.component';
import { PlatformService } from '../../core/services/platform.service';
import { SharedService } from '../../core/services/shared.service';
import { AuthService } from '../../core/services/auth.service';
import { LayoutService } from '../../core/services/layout.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit, OnDestroy {
  submitted: boolean = false;
  isShow = false;
  roleName: boolean;
  rolView: boolean;
  userName: string;
  isAccess: boolean;
  isAccessInstitution: boolean;
  isAccessCommunication: boolean;
  isAccessStaff: boolean;
  isAccessSub: boolean;
  isAccessAsset: boolean;
  subscription: Subscription;
  subscriptionFacility: Subscription;
  @Input() RightNavData: any;
  appTitle = 'Health Platform';
  roleValue;
  pinData: any;
  facilityAccountsView: boolean = false;
  userManagementView: boolean = false;
  pinLists: Array<any> = [];
  facilityAccounts: Array<any> = [];
  pinListschk: any;
  constructor(
    private router: Router, 
    private dhhpAlert: DhhpAlertComponent, 
    private _http: PlatformService, 
    private sharedService: SharedService, 
    private authService: AuthService, 
    private userService: LayoutService) { }

  ngOnInit() {
    this.userName = this.authService.getDisplay();
    if (this.userName != null || this.userName != undefined) {
      this.userService.userDisplay.next(this.userName);
    }
    this.roleValue = this.userService.getRoleValue;
    if (this.userService.getRoleValue == 'User') {
      this.roleName = false;
    } else {
      this.roleName = true;
    }
    if (this.userService.getRoleValue == 'Platform Trouble Shooter') {
      this.roleName = true;
      this.rolView = false;
    } else {
      this.rolView = true;
    }
    if (this.userService.userRoleData) {
      this.accessControl();
    } else {
      this.subscription = this.userService.getRoleValueAccess.asObservable().subscribe(res => {
        this.accessControl();
      })
    }
    this.getPinList();
    this.subscriptionFacility = this.userService.getProfileData$.subscribe(res => {
      if (Object.keys(res).length > 0) {
        this.facilityAccounts = res.facilityAccounts;
      }
      if (this.facilityAccounts && this.facilityAccounts.length > 0) {
        this.facilityAccountsView = true;
      } else {
        this.facilityAccountsView = false;
      }
      if (res.dhhpRoleId == "5de0138f9952be3f746353af") {
        this.userManagementView = true;
      } else {
        this.userManagementView = false;
      }
    });
  }
  accessControl() {
    this.isAccess = this.sharedService.IsRoleAccess('Platform Role Management', 'Platform Role Management', 'Access');
    this.isAccessInstitution = this.sharedService.IsRoleAccess('Institution Management', 'Access to Institution Management', 'Access');
    this.isAccessStaff = this.sharedService.IsRoleAccess('Staff Management', 'Manage Institution Users', 'Access');
    this.isAccessCommunication = this.sharedService.IsRoleAccess('Communication Management', 'Message', 'Access');
    this.isAccessSub = this.sharedService.IsRoleAccess('Subscription Management', 'Define Subcription plan', 'Access');
    this.isAccessAsset = this.sharedService.IsRoleAccess('Digital Asset Library', 'Access Digital Asset Library', 'Access');
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
    if (this.subscriptionFacility)
      this.subscriptionFacility.unsubscribe();
  }
  onChangeApp() {
    this.RightNavData.toggle();
    //this.passData = { key: "app", val: true }
    //this.childEvent.emit(this.passData);
  }
  getPinList() {
    this._http.GetPinnedDashboardAppsforUser(this.authService.getUserToken(), localStorage.getItem('countryVal')).subscribe(data => {
      if (data) {
        this.pinLists = data;
      }
    })
  }
  pinToDashboard(name, url, icon) {
    this.pinListschk = this.pinLists.find(res => res.name == name);
    if (this.pinListschk) {
      this.dhhpAlert.dhhpAlertError('Already pinned  in dashboard', '');
      return false;
    }
    const formData = {
      name: name,
      iconUrl: environment.Platform_URI_Redirect + '/' + icon,
      typeofApp: 'Function',
      applicationUrl: url,
      userId: this.authService.getUserToken(),
      createdOn: new Date()
    }
    this._http.AddPinToUserDashboard(formData).subscribe({
      next: (data: any) => {
        if (data) {
          //this.dhhpAlert.dhhpAlertConfirmation('Pin to dashboard successfully', '');
          this.router.navigateByUrl('/dashboard');
        }
      },
      error: err => { },
      complete: () => { }
    })
  }
}
